import React, { useState } from 'react';
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { P } from '../../../../../AbstractElements';
import { Action, AnotherAction, BasicTabs, Contact, dropdown, Hometxt, Modalcontent, Profile, SeparatedLink, SomethingElseHere } from '../../../../../Constant';
import TabsPreventDefaultAndAnimation from '../../../../../Hoc/TabsPreventDefaultAndAnimation';
import HeaderCard from '../../../../Common/HeaderCard';

const BasicTabCard = ({ show, tabActive, tabActiveHandler }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Col sm='12' xl='6 xl-100'>
      <Card>
        <HeaderCard title={BasicTabs} />
        <CardBody>
          <Nav tabs>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                {Hometxt}
              </NavLink>
            </NavItem>
            <Dropdown className='nav-items' isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle className={`nav-link dropdown-toggle bg-transparent border-none ${tabActive === '2' ? 'active' : ''}`} tag='a' href='#javascript' color='default' onClick={(e) => tabActiveHandler(e, '2')}>
                {dropdown}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem href='#javascript'>{Action}</DropdownItem>
                <DropdownItem href='#javascript'>{AnotherAction}</DropdownItem>
                <DropdownItem href='#javascript'>{SomethingElseHere}</DropdownItem>
                <DropdownItem href='#javascript'>{SeparatedLink}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                {Profile}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '4' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '4')}>
                {Contact}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={tabActive}>
            <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
              <P className='mb-0 m-t-30'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
              <P className='mb-0 m-t-30'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
              <P className='mb-0 m-t-30'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '4' ? show : ''}`} tabId='4'>
              <P className='mb-0 m-t-30'>{Modalcontent}</P>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(BasicTabCard);
